import { useTranslation } from "react-i18next"
import { SegmentedTabs } from "../../../../components/ui/segmented-tabs"

// Series colours = the overview chart (parts/SalesChartCard: indigo «Захиалсан»,
// teal «Хүргэсэн»). Never the brand colour: for some tenants it is red, which
// reads as "bad" on a margin or count line.
export const SERIES = {
  current : "var(--mantine-color-indigo-7)",
  previous: "var(--mantine-color-gray-5)",
  accent  : "var(--mantine-color-teal-7)",
}

export const AXIS_LABEL = { color: "var(--mantine-color-gray-7)", fontSize: "14px" }
export const GRID_LINE = "var(--mantine-color-gray-2)"
export const AXIS_LINE = "var(--mantine-color-gray-3)"

export const TOOLTIP = {
  shared         : true,
  backgroundColor: "var(--mantine-color-white)",
  borderColor    : "var(--mantine-color-gray-3)",
  borderRadius   : 8,
  style          : { fontSize: "14px" },
}

export const LEGEND = {
  align        : "left" as const,
  verticalAlign: "top" as const,
  itemStyle    : { fontSize: "14px", fontWeight: "500", color: "var(--mantine-color-gray-7)" },
}

/** «Энэ жил | Өмнөх жилтэй» — the same segmented control as the overview chart's «Дүн | Тоо». */
export function YoYToggle({ active, onToggle }: { active: boolean; onToggle: () => void }) {
  const { t } = useTranslation(["dashboard"])
  return (
    <SegmentedTabs
      value={active ? "yoy" : "current"}
      onChange={(v) => { if ((v === "yoy") !== active) onToggle() }}
      data={[
        { value: "current", label: t("analytics.thisYear") },
        { value: "yoy", label: t("analytics.toggleYoY") },
      ]}
      aria-label={t("analytics.toggleYoY")}
    />
  )
}
